import useSWR from 'swr';
import { getCountries } from './countriesService';
import { useCountriesStore } from './countriesStore';

export function useCountries() {
	const { setCountries } = useCountriesStore();

	return useSWR('countries', getCountries, {
		onSuccess: (countries) => {
			setCountries(countries.data);
		},
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		dedupingInterval: 3600000, // 1 hour
	});
}
